module.exports = __webpack_public_path__ + "media/images/writer/monitor/bg-bottom-header-f175c27fe94a895e77fc64864a671ab8.svg";